export function getMonthLength(curtime){ 
	if(curtime == 'year'){return ''};
		let timearry=curtime.split('-');
		if(timearry[1] == '01' || timearry[1] == '03' ||timearry[1] == '05' || timearry[1] == '07'||timearry[1] == '08' || timearry[1] == '10' || timearry[1] == '12'){
			return '31';
		}else if(timearry[1] == '04' || timearry[1] == '06' ||timearry[1] == '09' || timearry[1] == '11'){
			return '30';
		}else{
			if(timearry[0] / 4  == 0){
					return '29';
			}else{
					return '28';
			} 
		} 
			
};

//获取当前日期的前11个月，也就是最近一年的数据
export function GetPreMonthDay(date, monthNum) {
 var dateArr = date.split('-');
 var year = dateArr[0]; //获取当前日期的年份
 var month = dateArr[1]; //获取当前日期的月份
 var day = dateArr[2]; //获取当前日期的日
 var days = new Date(year, month, 0);
 days = days.getDate(); //获取当前日期中月的天数
 var year2 = year;
 var month2 = parseInt(month) - monthNum;
 if (month2 <= 0) {
	 var absM = Math.abs(month2);
	 year2 = parseInt(year2) - Math.ceil(absM / 12 == 0 ? 1 : parseInt(absM) / 12);
	 month2 = 12 - (absM % 12);
 }
 var day2 = day;
 var days2 = new Date(year2, month2, 0);
 days2 = days2.getDate();
 if (day2 > days2) {
	 day2 = days2;
 }
 if (month2 < 10) {
	 month2 = '0' + month2;
 }
 var t2 = year2 + '-' + month2 + '-1'; //+ day2;
 console.log(date,monthNum,t2);
 return t2
};

//获取当前日期用于时间筛选  
export function getCurrentDate() {
	const now = new Date();
	const year = now.getFullYear();
	const month = now.getMonth() + 1; // 月份是从0开始的，所以需要加1
	const day = now.getDate();
	let curDate =  year+'-'+ month.toString().padStart(2, '0') +'-'+ day.toString().padStart(2, '0');
	//`${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
	console.log('当前日期',curDate);
	return curDate;
};

/**
 * 根据当前月份获取其前六个月的月份
 * @param month
 * @return {Array|*}
 */
 export function getRecentMonth(month) {
	let arr = []
	for(let i = 5;i > 0;i --) {
		let sixMonth = month - i
		if(sixMonth <= 0) {
			sixMonth = 12 + sixMonth
		}
		arr.push(sixMonth + '月')
	}
	arr.push(month + '月')
	return arr;
}

